import   React,
       { useEffect,
         useState,
         useRef,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Switch,
         Button,
         Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight,
         faTimes,
         faEnvelope } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import * as d3 from "d3";  
import { appContext } from "./index";
import { sleep } from "../util/tools";  
import { UTIL_useStyles,
        } from "./Util";  
import { INFO } from '../util/object';


export const graph_useStyles = makeStyles(theme => ({
    graph_container: {
        display: 'flex',
        position: 'absolute',
        width: '50vw',
        height: '40vh',
        margin: '0',
        marginTop: '10vh',
        minHeight: '300px',
        minWidth: '400px',
        padding: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        zIndex: '500',
        overflow: 'auto',
    },
    graph_dialog_container: {
        //height: '30vh',
        //width: '50vw',
        height: '100%',
        width: '100%',
        paddingTop: '0',
        paddingBottom: '15px',
        justifyContent: 'center',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        overflow: 'hidden',
    },
}))




const LineChart = (props) => {
    const classes = graph_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState.goback:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }

    //const data = Object.assign((d3.csvParse(await FileAttachment("aapl.csv").text(), d3.autoType)).map(({date, close}) => ({date, value: close})), {y: "$ Close"})
    const margin = {top: 20, right: 30, bottom: 30, left: 30}
    const width = 400
    const height = 250;     // 300
    //const [ SVG, setSVG ] = useState(null);
    const [ Refresh, setRefresh ] = useState(0);
    const [ Second, setSecond ] = useState(0);
    //var svg = null;

    useEffect(() => {
        setRefresh(Date.now());

        return function cleanup() {
            setSecond(0);
            //INFO.svg = null;      do it later
        }
    }, [1]);


    useEffect(() => {
        //console.log("line.46: REFRESH ", Refresh, " History=", props.History);
    }, [Refresh]);


    // update the graph as new data comes in
    useEffect(() => {
        var history0 = [];
        if((props.History == undefined) || (props.History == null) || (props.History.length == 0) || (props.Fields == undefined) || (props.Fields == null)) {
            return;
        }
        //history0 = [...props.History];
        history0 = props.History.map((x) => {return({...x})});      // ARRAY DEEP COPY
        for(var i = 0; i < history0.length; i++) {
            history0[i][props.Fields] = 0;
        }
        INFO.svg = line_init(history0, props.Fields);      // start with zero then do animation up
        setSecond(Second + 1);
        console.log("line.117: NEW HISTORY ", Refresh, " history0=", history0.length);  //, " svg=", INFO.svg);
    }, [props.History, props.Fields]);


    // first graph shows flat line, second graph does animation to display actual data
    //
    useEffect(() => {
        doSecond();
    }, [Second]);

    async function doSecond() {
        if((props.History == undefined) || (props.History == null) || (props.Fields == null)) {
            console.log("line.122: FAILED SECOND HISTORY History=",props.History, "  Fields=",props.Fields);
            return;
        }
        await sleep (600);
        //console.log("line.56: Start Second  History=", props.History);
        //line_chart(SVG, data1);
        console.log("line.128: SECOND HISTORY  refresh=", Refresh, " props.History=", props.History.length, "  props.Fields=",props.Fields.length);      //, "  SVG=", INFO.svg);
        line_chart(INFO.svg, props.History, props.Fields);
        setRefresh(Date.now());
    }


const line_init  = (data, field) => {
    const xAxis = (g) => {
        g.attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x).ticks(width / 80).tickSizeOuter(0))
    }

    const yAxis = (g) => {
        g.attr("transform", `translate(${margin.left},0)`)
        g.call(d3.axisLeft(y))
        .call(g => g.select(".domain").remove())
    }
    const line = d3.line()
            .defined(d => !isNaN(d[field]))
            .x(d => x(d.idx))
            .y(d => y(d[field]))

    const x = d3.scaleUtc()
                .domain(d3.extent(data, d => d.idx))
                .range([margin.left, width - margin.right])

    const y = d3.scaleLinear()
                .domain([0, d3.max(data, d => d[field])]).nice()
                .range([height - margin.bottom, margin.top])

        var svg = d3.select("#chart_"+props.ID)
        //.style("width", width+"px")
        //.style("height", height+"px")
        //.style("margin-top", 300+"px")
        //.style("margin-left", 300+"px")
        .style("background", "#ddd")
        .style("z-index", 600)
        .append("svg")
        .attr("viewBox", [0, 0, width, height])
        .style("height", "auto")
        .style("width", "auto")
        .style("margin", "10px")

        svg.append("g")
            //.transition()
            //.duration(3000)
            .attr("class","myX")
            .call(xAxis)

        svg.append("g")
            //.transition()
            //.duration(3000)
            .attr("class","myY")
            .call(yAxis);

        svg.append("g")
            .append("path")
            .datum(data)
            .attr("class","lineTest")
            .attr("fill", "none")
            .attr("stroke", "red")
            .attr("stroke-width", 2.5)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .attr("d", line);

        return svg;
    }


    const line_chart  = (svg, data, field) => {
        if(svg == null) {
            console.log("line_chart.199:  NO SVG!!!");
            return;
        }
        const xAxis = (g) => {
            g.attr("transform", `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x).ticks(width / 80).tickSizeOuter(0))
        }

        const yAxis = (g) => {
            g.attr("transform", `translate(${margin.left},0)`)
            g.call(d3.axisLeft(y))
            .call(g => g.select(".domain").remove())
        }
        const line = d3.line()
                .defined(d => !isNaN(d[field]))
                .x(d => x(d.idx))
                .y(d => y(d[field]))

        const x = d3.scaleUtc()
                .domain(d3.extent(data, d => d.idx))
                .range([margin.left, width - margin.right])

        const y = d3.scaleLinear()
                .domain([0, d3.max(data, d => d[field])]).nice()
                .range([height - margin.bottom, margin.top])

        // Create a update selection: bind to the new data
        var u = svg.selectAll(".lineTest")
            .data([data], function(d){ return d.idx });

        svg.selectAll(".myY")
            .call(xAxis);

        svg.selectAll(".myX")
            .call(yAxis);

        svg.selectAll(".lineTest")
            .merge(u)
            .transition()
            .duration(3000)
            .attr("class","lineTest")
            .attr("fill", "none")
            .attr("stroke", "red")
            .attr("stroke-width", "3px")
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .attr("d", line);

            return svg;
    }

    return (
        <React.Fragment>
            <Container id={"graph_container"+props.ID} className={classes.graph_container} >
                <Container id={"chart_"+props.ID} className={classes.graph_dialog_container} >
                    <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                            <FontAwesomeIcon 
                                className={Classes.logo_icon}
                                icon={faTimes}
                                size="2x" />
                    </Container>

                </Container>
            </Container>
        </React.Fragment>
    )
}


// UTIL
// For display daily scores
//
// src: https://www.pluralsight.com/guides/drawing-charts-in-react-with-d3

const bargraph_useStyles = makeStyles(theme => ({
    bargraph_container: {
        height: 'calc(100% - 10px)',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        margin: '0',
        padding: "10px 10px 10px 10px",
    },
    bargraph_canvas: {
        height: '100%',
        width: '100%',
    },
    bargraph_title: {
        padding: '0',
		fontSize: '1.0rem',
        paddingLeft: '3vw',
        alignSelf: 'center',
        lineHeight: '1.4rem',
    },
}));

//function BarGraph({ width, height, data }){
function BarGraph(props){
    const classes = bargraph_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    const ref = useRef();

    useEffect(() => {
        const svg = d3.select(ref.current)
            .attr("width", "100%")   // width
            .attr("height", "100%")     // height
            //.style("border", "1px solid black")
    }, [1]);


    useEffect(() => {
        if ((props.Data !== undefined) && (props.Data.length > 0)) {
            draw();
        }
    }, [props.Data]);


    const X_BAR_OFFSET = 25;
    const X_AXIS_OFFSET = 60;       // 60
    const AXIS_X_ORIGIN = 25;
    const AXIS_Y_ORIGIN = 20;        // 15
    const AXIS_Y_ORIGIN0 = 10;        // 15
    //const AXIS_Y_ORIGIN0 = 0; 
    const AXIS_Y_OVERSHOOT = 20;        // 10, 15
    //const AXIS_Y_OVERSHOOT = 30;
    const draw = () => {
        //console.log("init.205: .......STAR DRAW() data=",props.Data.length," ", Date.now());
        var data = props.Data;
        var cnt = props.Data.length;
        var days = ["Su", "M", "Tu", "W", "Th", "F", "Sa" ];

		var graph = document.getElementById('scores_carousel_container');
		var wwidth = graph.offsetWidth;
		var wheight = graph.offsetHeight;	
		var width = wwidth - 10;
		var height = wheight - ((cnt === 7) ? 50 : 35);	    // good
        //console.log("draw.307:  width=",width, " height=",height);      //, "  graph=",graph);

        var bar_width = (width / ((props.Data.length + 1) * 1.1));
        var bar_gap = (bar_width * 0.1);
        //console.log("draw.332:  data.len=",props.Data.length, " data=",props.Data);

        const svg = d3.select(ref.current);
        var selection = svg.selectAll("rect").data(props.Data);
        var yScale = d3.scaleLinear()
                            .domain([0, d3.max(props.Data) + AXIS_Y_OVERSHOOT])        // input data
                            //.range([0, height-100]);
                            .range([ 0, height ]);            // output range

        const get_color = (val) => {
            if (val == 0){
                //console.log("color: got red");
                return "#bbb";
            } else {
                return "orange";
            }
        }

        // show a grey stub if data is zero
        //
        const y_stub = (val) => {
            if (val == 0) {
                //console.log("color: got stub");
                return 8;
            } else {
                //console.log("color: no stub val=",val);
                return 0;
                //return -10;     // SUPER KLUDGE: NEED TO DO THIS ELSEWHERE!!!
            }
        }

        
        selection
            .transition().duration(1200)
                //.attr("height", (d) => yScale(d))
                //.attr("y", (d) => height - yScale(d))
                .attr("height", (d) => yScale(d) + y_stub(d))
                //.attr("y", (d) => height - yScale(d) - y_stub(d))      // shift up, only works for clark?
                .attr("y", (d) => height - yScale(d) - y_stub(d) - 10)      // shift up, only works for clark?

        selection
            .enter()
            .append("rect")
            //.attr("x", (d, i) => i * bar_width)
            .attr("x", (d, i) => (((i) * bar_width) + X_BAR_OFFSET))
            //.attr("y", (d) => height)
            .attr("y", (d) => height)
            .attr("width", (bar_width - bar_gap))
            .attr("height", 0)
            .attr("fill", (d) => get_color(d))
            .transition().duration(1200)
                //.attr("height", (d) => yScale(d))
                //.attr("y", (d) => height - yScale(d))
                .attr("height", (d) => yScale(d) + y_stub(d))
                //.attr("y", (d) => height - yScale(d) - y_stub(d))
                .attr("y", (d) => height - AXIS_Y_ORIGIN0 - yScale(d) - y_stub(d))     // shift up, only works for clark?
                //.attr("y", (d) => height - AXIS_Y_ORIGIN0 - yScale(d) - y_stub(d) - 10)     // shift up, only works for clark?
        
        selection
            .exit()
            .transition().duration(1200)
                .attr("y", (d) => height)
                .attr("height", 0)
            .remove()



        // axis lable experiment
        // src: https://stackoverflow.com/questions/11189284/d3-axis-labeling



        // Create axis scale
        // src: https://www.tutorialsteacher.com/d3js/axes-in-d3 << GOOD

        //console.log("graph.412:      .  .  .  .  RENDER BAR GRAPH  cnt=",cnt, " data=",data);
        var xScale = d3.scaleBand()
                    //.domain([0, cnt])             // works? domain is input data
                    .domain(days.map((d)=>{return d}))       // domain is input data
                    .range([ 0, width - X_AXIS_OFFSET ]);         // range is output display

        var y1Scale = d3.scaleLinear()
                    //.domain([d3.min(data), d3.max(data)])
                    .domain([0, d3.max(data) + AXIS_Y_OVERSHOOT])       // input data
                    .range([ height - AXIS_Y_ORIGIN, 0 ]);      // must be reversed


        // Add scales to axis
        if (cnt === 7) {
            var x_axis = d3.axisBottom()
                    .scale(xScale)
                    .ticks(7)
                    //.tickValues(["S", "M", "T", "W", "T", "F", "S"])     //specify an array here for values

            //Append group and insert axis
            var xAxisTranslate = height - (AXIS_Y_ORIGIN - 10);     // shifts X-axis up
            svg.append("g")
                .attr("transform", "translate("+AXIS_X_ORIGIN+ "," + xAxisTranslate  +")")
                .call(x_axis)
        }

        // Add scales to axis
        var y_axis = d3.axisLeft()
                    .scale(y1Scale)
                    .ticks(5)

        svg.append("g")
        .attr("transform", "translate("+AXIS_X_ORIGIN+ "," + (AXIS_Y_ORIGIN - 10) +")")     // shifts Y-axis up
        .call(y_axis);


        /* from LineChart();
        const yAxis = (g) => {
            //g.attr("transform", `translate(${margin.left},0)`)
            g.call(d3.axisLeft(y))
            .call(g => g.select(".domain").remove())
        }
        svg.append("g")
                .call(yAxis)
        */

            /*
            //var formatAxis = d3.format("  0");
            //var axis = d3.svg.axis()
            var axis = svg.axis()
                    .scale(yScale)
                    //.tickFormat(formatAxis)
                    .ticks(3)
                    .tickValues([100, 200, 300]) //specify an array here for values
                    .orient("left");
            */

    }


            //<Typography className={classes.bargraph_title}> {props.Title} </Typography>
    return (
        <div id="score_container" className={classes.bargraph_container}>
            <div id="score_canvas" className={classes.bargraph_canvas}>
                <svg ref={ref} />
            </div>
        </div>
    )

}



export { LineChart, BarGraph }
